import { DocumentViewMode } from "~/types/enums/DocumentViewMode.enum";

export const useGenerateDocumentPath = (
  submittedDocument: SubmittedDocument,
  mode: DocumentViewMode,
  isAutoReturnEnabled: boolean = true
): string | undefined => {
  if (useCanGradeDocument(submittedDocument, mode) == false) return undefined;

  if (mode == DocumentViewMode.student) {
    // If we're in student mode and the document is not graded or in student review
    // Then it doesn't matter if the teacher returned it or not. 
    // -- This might change if we allow a teacher to return documents that are ungraded.
    if (
      [DocumentState.graded, DocumentState.studentReview].includes(
        submittedDocument.state
      ) != true
    ) {
      return undefined;
    }


    // If auto return is not enabled and the document has not been marked as returned
    // Then we do not allow the student to view it.
    if (
      isAutoReturnEnabled != true &&
      submittedDocument.isReturnedToStudent != true
    ) {
      return undefined;
    }
  }

  return useIsDocumentReadyToGrade(submittedDocument)
    ? `/documents/${mode}/review/${submittedDocument.id}`
    : undefined;
};
